import { useContext } from 'react'
import { SessionContext } from '../providers/SessionProvider'
import { SessionData } from '../typings/SessionData'

const EMPTY = {}

export function useSession(): SessionData {
  return useContext(SessionContext) || EMPTY
}
